import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { EmployeeModel } from '../../../../../../shared/store/employee/types';
import { EmployeeService } from '../../../../../../shared/store/employee/employee.service';

@Component({
    selector: 'app-employee-details-parameters',
    templateUrl: './employee-details-parameters.component.html',
    styleUrls: ['./employee-details-parameters.component.scss'],
    standalone: false
})
export class EmployeeDetailsParametersComponent {
  employeeDetail$: Observable<EmployeeModel>;

  constructor(private readonly employeeService: EmployeeService) {
    this.employeeDetail$ = this.employeeService.getById.value$;
  }
}
